import React from "react";
import CommonImageSlider from "./comandata";
import CallandRegisterComponent from "./Callbutton";
import {neetImages } from "./data";
import SeoMeta from "./seometa/seometa";
import WhyRankridgeNEET from "./neetlongterm";
import CommonImageSliderRanks from "./CommonsliderRanks";
import { CommonAboutHeader } from "./CommonAboutHeader";
import { AboutSection, HeroSection } from "./courses/commoncomponents";
import { ContactCTA } from "./subcomponents/Rankridgebipcneet";
const seoNEET = {
  title: "Best NEET Coaching in Hyderabad | Long Term NEET Coaching",
  description: "Join Rankridge, the trusted NEET coaching institute in Hyderabad. Long term NEET coaching with expert faculty & proven top results.",
  keywords: "NEET Long Term Coaching Hyderabad, Best NEET Coaching in Hyderabad, NEET Long Term Course Hyderabad, Rankridge NEET Long Term Program, NEET Foundation Junior College Hyderabad, Medical Entrance Coaching Junior College Hyderabad, Best NEET Preparation Colleges in Hyderabad, NEET Training Junior College Hyderabad, Top NEET Junior Colleges Hyderabad, NEET Residential Coaching Hyderabad, NEET Coaching with Hostel Facility, Best NEET Residential Junior Colleges, NEET Coaching KPHB Hyderabad, NEET Long Term Classes Hyderabad, Rankridge NEET Coaching Hyderabad, Junior College with NEET Coaching Hyderabad, BiPC with NEET Foundation Hyderabad, NEET Coaching Near Kukatpally, NEET Coaching Near Hitech City, Best Intermediate Colleges for NEET, NEET Coaching Admissions Hyderabad, NEET Preparation Junior College Hyderabad, Top Junior Colleges for Medical Entrance Exams, NEET Long Term Coaching Rankridge, Best BiPC Residential Colleges Hyderabad",
  canonical_path: "https://www.rankridge.com/neet-coaching-in-hyderabad/",
  og_description: "",
  og_image: "",
};

const title=`Best NEET LONG TERM Coaching  in Hyderabad`
const courseName1='' 
const courseName2=""
const titleend=''
const symbol=""
const description="At Rankridge Junior College, our Best MPC with IIT-JEE program blends Intermediate curriculum with focused coaching for IIT-JEE Mains & Advanced. With IITian faculty, concept clarity sessions, and regular practice tests, we prepare students for top engineering colleges across India."
const heroImage=neetImages[3]

const aboutTitle='About Rankridge NEET Long-Term Coaching'
const aboutDescription=`Rankridge College is Hyderabad’s most trusted destination for NEET long-term coaching, guiding aspirants to secure seats in AIIMS, JIPMER, and top government medical colleges. With expert faculty from AIIMS, IITs, and premier institutions, we combine strong NCERT fundamentals with advanced problem-solving strategies to ensure complete exam readiness.
Our proven track record of 1200+ selections in the past 3 years and 20+ students scoring above 680 marks reflects the dedication and precision of our programs. Students benefit from small batch sizes, daily practice problems, doubt-solving sessions, and one-on-one mentoring that make learning personal and effective.` 
const description2='Beyond academics, Rankridge ensures a holistic environment with stress-free study schedules, digital classrooms, nutritious food, and world-class hostel facilities. With both residential and day scholar options.' 
const imagePath=neetImages[1] 

const NeetLongTerm = () => {
  return (
    <div>
       
    
    {/* <div className="bg-white text-[#0e1b3d] px-4 sm:px-6 md:px-10 lg:px-20 xl:px-32 2xl:px-48 py-1 space-y-4"> */}
      {/* Tagline Section */}

        {/* <CommonAboutHeader images={neetImages}/>
   

     <CommonImageSliderRanks images={neetRankImages}/>
       <div className="mb-1 mt-3 me-2 ms-2">
<CallandRegisterComponent />



</div> */}

<HeroSection sparktext="Best NEET Long-Term Coaching in Hyderabad" description={description}  title={title}  courseName1={courseName1} courseName2={courseName2} titleend={titleend} symbol={symbol} imagePath={heroImage}  />
<AboutSection title={aboutTitle} description={aboutDescription} description2={""} imagePath={imagePath}   />

<section>


  
  <WhyRankridgeNEET />

</section>

<ContactCTA />
    {/* </div> */}

<SeoMeta seopages={seoNEET} />

    </div>
  );
};

export default NeetLongTerm;